// Shared helper: resolves dataGroup question KEYS (what the UI selects) down
// to the flattened raw SPSS variable NAMES (what the backend/df columns use).
export function resolveKeysToVarNames(keys, dataGroup) {
  return (Array.isArray(keys) ? keys : [keys])
    .filter(Boolean)
    .flatMap((key) => (dataGroup[key]?.varName || []).map((v) => v.Name))
    .filter(Boolean);
}
